module.exports = __webpack_public_path__ + "assets/img/email.fab26f11.svg";